// extracted by mini-css-extract-plugin
module.exports = {"row":"Dashboard_row__1LqG8","title":"Dashboard_title__2Nvrd","content":"Dashboard_content__3AF1O","contentItem":"Dashboard_contentItem__6ao5o"};